import { useState, useEffect } from 'react';
import { css } from '@eti/styles';
import { useSiteContext } from '@eti/providers';
import { Button, Text, textVariants } from '@etg/wings';
import { useMediaQuery } from 'usehooks-ts';
import { getSeatIconComponent } from '../../utils/getSeatIconComponent';
import { seatButtonStyles } from '../../utils/styles';
import SeatTooltip from './SeatTooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const selectedSeatInitialsStyles = css`
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
`;
const BookableSeat = _ref => {
  let {
    carrier,
    column,
    row,
    onChange,
    price,
    seat,
    isSelected,
    mainCharacteristic,
    markup,
    selectedSeatInitials
  } = _ref;
  const {
    brand
  } = useSiteContext();
  const tooltipId = `seat_${seat}`;
  const [SeatIconComponent, setSeatIconComponent] = useState();
  const isDesktop = useMediaQuery(`(min-width: 1200px)`);
  useEffect(() => {
    const loadIcon = async () => {
      const iconComponent = await getSeatIconComponent(brand.code, mainCharacteristic, isSelected);
      setSeatIconComponent(() => iconComponent);
    };
    loadIcon();
  }, [brand, mainCharacteristic, isSelected]);
  const handleClick = onChange({
    price,
    carrier,
    column,
    row,
    seat,
    markup
  });
  return /*#__PURE__*/_jsxs(Button, {
    "aria-describedby": tooltipId,
    className: seatButtonStyles,
    "data-for": tooltipId,
    "data-seat-id": `bookableSeat-${row}-${seat}`,
    "data-testid": `bookableSeat-${row}-${seat}`,
    "data-tip": true,
    onClick: handleClick,
    children: [isSelected && /*#__PURE__*/_jsx(Text, {
      className: selectedSeatInitialsStyles,
      variant: textVariants._12_BOLD,
      children: selectedSeatInitials
    }), SeatIconComponent && /*#__PURE__*/_jsx(SeatIconComponent, {}), (!isDesktop || !isSelected) && /*#__PURE__*/_jsx(SeatTooltip, {
      id: tooltipId,
      price: price,
      seat: seat
    })]
  });
};
export default BookableSeat;
//# sourceMappingURL=BookableSeat.js.map